import type { JSX } from 'react'

import {
  HashtagIcon,
  IgProductTagIcon,
  IgTextIcon,
  LinkIcon,
  MusicIcon,
  PlusIcon,
} from '@buffer-mono/popcorn'
import { PostFields } from '@buffer-mono/reminders-config'

export function StickerIcon({ field }: { field: PostFields }): JSX.Element {
  switch (field) {
    case PostFields.MUSIC:
      return <MusicIcon size="xsmall" />
    case PostFields.LINK:
      return <LinkIcon size="xsmall" />
    case PostFields.OTHER:
      return <PlusIcon size="xsmall" />
    case PostFields.TEXT:
      return <IgTextIcon size="xsmall" />
    case PostFields.TOPICS:
      return <HashtagIcon size="xsmall" />
    case PostFields.PRODUCTS:
      return <IgProductTagIcon size="xsmall" />
    default:
      return <MusicIcon size="xsmall" />
  }
}
